/**
 * Compatibility shim — all pinned widget state now lives in useWidgetPreferences
 * under the unified 'dashboard-prefs' localStorage key.
 */
import { useWidgetPreferences, type PinnedWidget } from './useWidgetPreferences';

export type { PinnedWidget };

export const usePinnedWidgets = () => {
  const { pinnedWidgets, pinWidget, unpinWidget, isPinned } = useWidgetPreferences();
  return { widgets: pinnedWidgets, pinWidget, unpinWidget, isPinned };
};
